module.exports = __webpack_public_path__ + "static/media/bob_barker_sticker_face_2.168906b7.png";